import { consts } from '../actions/InfluencerMapActions';

const initialState = {
  
  fetched: false,
  fetching: false,
  error: null,
  getInfluencerMapGroupsFetching: false,
  getInfluencerMapGroupsData: {},

  addInfluencerMapGroupsFetching: false,
  addInfluencerMapGroupsData: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    
    case consts.GET_INFLUENCER_MAP_GROUPS_PENDING: {
      state = Object.assign({}, state, { getInfluencerMapGroupsFetching: true});
      break;
    }
    case consts.GET_INFLUENCER_MAP_GROUPS_FULFILLED: {
        state = Object.assign({}, state, { getInfluencerMapGroupsFetching: false, getInfluencerMapGroupsData: action.data });
        break;
    }
    case consts.GET_INFLUENCER_MAP_GROUPS_REJECTED: {
      state = Object.assign({}, state, { error: action.error });
      break;
    }

    case consts.ADD_INFLUENCER_MAP_GROUPS_PENDING: {
      state = Object.assign({}, state, { getInfluencerMapGroupsFetching: true});
      break;
    }
    case consts.ADD_INFLUENCER_MAP_GROUPS_FULFILLED: {
        state = Object.assign({}, state, { getInfluencerMapGroupsFetching: false, addInfluencerMapGroupsData: action.data });
        break;
    }
    case consts.ADD_INFLUENCER_MAP_GROUPS_REJECTED: {
      state = Object.assign({}, state, { error: action.error });
      break;
    }

    case consts.EDIT_INFLUENCER_MAP_GROUPS_PENDING: {
      state = Object.assign({}, state, { getInfluencerMapGroupsFetching: true});
      break;
    }
    case consts.EDIT_INFLUENCER_MAP_GROUPS_FULFILLED: {
        state = Object.assign({}, state, { getInfluencerMapGroupsFetching: false, addInfluencerMapGroupsData: action.data });
        break;
    }
    case consts.EDIT_INFLUENCER_MAP_GROUPS_REJECTED: {
      state = Object.assign({}, state, { error: action.error });
      break;
    }
    
  }
  return state;
}





// WEBPACK FOOTER //
// ./src/store/reducers/InfluencerMapReducer.js